import React from 'react'

function TeamPage() {
  return (
    <div>TeamPage</div>
  )
}

export default TeamPage